import { WithServiceId } from '@mews-commander/types';
import { useRepositoryQuery } from '@mews-commander/data-access';
import { useServiceInfo } from '@mews-commander/legacy-entities/src/utils/useServiceInfo';

export const useSelectedService = ({ enterpriseId, serviceId }: WithServiceId & { enterpriseId?: string }) => {
    const { service } = useServiceInfo(serviceId);

    const { data } = useRepositoryQuery(
        'services',
        'getAll',
        {
            enterpriseIds: enterpriseId ? [enterpriseId] : [],
            serviceIds: [serviceId],
        },
        {
            enabled: !service && !!(enterpriseId && serviceId),
        }
    );

    return service || data?.services?.[0];
};
